var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-spinner"},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":"circle-notch","spin":"","size":"3x"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }